import {
  TOGGLE_IS_CLOSING_VARIABLE,
  TOGGLE_MOBILE_OPEN_VARIABLE,
} from "../constants";

export const toggleIsClosingVariable = (data) => ({
  type: TOGGLE_IS_CLOSING_VARIABLE,
  payload: data,
});

export const toggleMobileOpenVariable = (data) => ({
  type: TOGGLE_MOBILE_OPEN_VARIABLE,
  payload: data,
});
